// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__v9zTc","no_top_space":"Separator_no_top_space__qOgHX","no_bottom_space":"Separator_no_bottom_space__nMgvX","fadeInOut":"Separator_fadeInOut__jou29"};